import React from 'react';
import Axios from 'axios';

// TENBALL version - single and double matchs, victory points
// This component is DIFFERENT since we are splitting stats into different category arrays

// Constants for this standings
const CST_CLASS = 'Classe';
const cstTableHeaders = [
	'Rang',	'Joueur',	CST_CLASS, 'SMOY', 	'MOY',	'PJ', 	'VIC', 	'TP', 	'TC', 	'TBB', 	'Équipe' ];

const cstDefaultSortOrder = [
	'',		'asc',		'asc', 	  'desc', 	'desc',	'desc', 'desc',	'desc', 'desc', 'desc',	'asc' ];

const cstTeamFieldIdx = 10;

const cstFixedDecimalsStats = [
	{fieldIdx: 3, decimals: 1},
	{fieldIdx: 4, decimals: 1}
];

const cstDefaultSortFieldIdx = 4;

const cstStandTypes = ['Tous', 'Simple', 'Double'];

class PlayerStandings_10B extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			sortFieldIdx: cstDefaultSortFieldIdx,
			sortOrder: cstDefaultSortOrder[cstDefaultSortFieldIdx],
			sortStandingIdx: 0,
			standings: [],
			standingsData: [],
			standingIdx: 0			// defaut type is Single Standings (players have problems understanding the defaut "All Players" standings
		};
	
		this.createSelectItem = this.createSelectItem.bind(this);
		this.standTypeChange = this.standTypeChange.bind(this);
		this.createStandingHdrRow = this.createStandingHdrRow.bind(this);
		this.createStandingRow = this.createStandingRow.bind(this);
		this.createDataCell = this.createDataCell.bind(this);
		this.handleSortTable = this.handleSortTable.bind(this);
	}

	componentDidMount() {
		this.initStandings(this.props);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		this.initStandings(nextProps);
	}

	initStandings(props) {
		var standings = props.standings;
		standings = this.createStandingsData(standings);
		this.setState({
			standings: standings,
			standingIdx: props.standingIdx
		});
	}

	createStandingsData(standings) {
		var _this = this;
		var standingsData = [];
		var stdIdx = 0;
		var newStandings = [];

		// Parse standings to get Tot, Sgl, Dbl, Teams for each one
		// Div1 becomes Div1-Tot, Div1-Sgl, Div1-Dbl, Div1-Teams
		// Div2 becomes Div2-Tot, Div2-Sgl, Div2-Dbl, Div2-Teams
		// Div... becomes Div...-Tot, Div...-Sgl, Div...-Dbl, Div...-Teams
		// Gen becomes Gen-Tot, Gen-Sgl, Gen-Dbl, Gen-Teams
		// Subs becomes Subs-Tot, Subs-Sgl, Subs-Dbl, Subs-Teams

		// Parse standings
		standings.forEach(function(standItem, standIdx) {

			var divStandings = [];
			stdIdx = divStandings.length;
			divStandings[stdIdx + 0] = [];
			divStandings[stdIdx + 1] = [];
			divStandings[stdIdx + 2] = [];

			var tableData = [];

			// Parse results
			standItem.results.forEach(function(result, resultIdx) {

				// Special conditions for Team column
				var teamCol = '';
				if (standItem.showTeam) {
					teamCol = result.teamName;
				}

				// Multiple players ?
				var playerNamesStr = '';
				var playerRatingStr = '';
				var delimChar = '';

				for(var idx = 0; idx < result.playersName.length; idx++) {
					if(idx !== 0) {delimChar = ' & ';}
					playerNamesStr += delimChar + result.playersName[idx];
					playerRatingStr += delimChar + result.playersRating[idx].strValueWithTemp;
				}

				var avg = 0;
				if (result.gamesPlayed !== 0) { 
					avg = (result.gamesWon / result.gamesPlayed * 100);		// toFixed(1)
				}
				var smoy = 0;
				if (result.gamesPlayed !== 0) { 
					smoy = (result.gamesWon + result.ero * 1.25) / (result.gamesPlayed - result.eroContre) * 100;
				}

				var standingRow = [];
				standingRow.push(0);
				standingRow.push(playerNamesStr);
				standingRow.push(playerRatingStr);
				standingRow.push(smoy);
				standingRow.push(avg);
				standingRow.push(result.gamesPlayed);
				standingRow.push(result.gamesWon);
				standingRow.push(result.ero);
				standingRow.push(result.eroContre);
				standingRow.push(result.tbb);
				standingRow.push(teamCol);

				// All players
				divStandings[stdIdx + 0].push(standingRow.slice());

				// Single players
				if (result.playersName.length === 1) {
					divStandings[stdIdx + 1].push(standingRow.slice());
				}

				// Double players
				if (result.playersName.length === 2) {
					divStandings[stdIdx + 2].push(standingRow.slice());
				}
			});

			// Build StandingsData multi-dimensionnal array
			divStandings.forEach(function(divStand, divStandIdx) {
				standingsData.push(divStand.slice());

				// Working
				// splitted standings - MUST push individual item values
				newStandings.push({
					order: standItem.order,
					results: standItem.results.slice(),		// values
					showTeam: standItem.showTeam,
					title: standItem.title,
					standType: cstStandTypes[divStandIdx]
				});
			});
		});

		// First data sort
		var sortFieldIdx = cstDefaultSortFieldIdx;
		var sortOrder = cstDefaultSortOrder[cstDefaultSortFieldIdx];

		standingsData.forEach(function (standingsItemData, standingsIdx) {
			_this.sortOneStandingsData(standingsItemData, standingsIdx, sortFieldIdx, sortOrder);
		});

		return newStandings;
	}

	resetAllSorting() {
		var _this = this;
		var standingsData = this.state.standingsData;
		var sortFieldIdx = cstDefaultSortFieldIdx;
		var sortOrder = cstDefaultSortOrder[sortFieldIdx];

		standingsData.forEach(function (standingsItemData, standingsIdx) {
			_this.sortOneStandingsData(standingsItemData, standingsIdx, sortFieldIdx, sortOrder);
		});

		this.setState({
			sortFieldIdx: sortFieldIdx,
			sortOrder: sortOrder,
		});
	}

	sortOneStandingsData(standingsItemData, standingsIdx, sortFieldIdx, sortOrder) {
		var _this = this;
		// Manage empty data
		if (standingsItemData.length !== 0) {

			var sortSign = 1;
			if (sortOrder === 'desc') { 
				sortSign = -1; 
			}

			var bSortClass = (cstTableHeaders[sortFieldIdx] === CST_CLASS);

			standingsItemData.sort(function(a, b) {

				var valueA = a[sortFieldIdx];
				var valueB = b[sortFieldIdx];
				var compVal = 0;

				switch(typeof valueA) {
				    case "date":
						compVal = new Date(valueA) - new Date(valueB);
				        break;
				    case "string":
				    	// class exception
				    	if (bSortClass) {
				    		var scabA = _this.getScabClassPoints(valueA);
				    		var scabB = _this.getScabClassPoints(valueB);
							compVal = scabB - scabA;	// opposite of alphabetic sorting
				    	} else {
							compVal = valueA.localeCompare(valueB);
						}
				        break;
				    case "number":
						compVal = valueA - valueB;
				        break;
				    default:
				        break;
				}

				if (compVal !== 0) return (sortSign * compVal);
				return (a[0] - b[0]);
			});
		}

		// Reset Rank column
		if (standingsItemData.length !== 0) {
			if (standingsItemData[0].length !== 0) {
				if (standingsItemData[0][0] !== "") {
					standingsItemData.forEach(function(row, idx) {
						row[0] = idx + 1;
					});
				}
			}
		}

		var standingsData = this.state.standingsData;
		standingsData[standingsIdx] = standingsItemData;

		this.setState({
			standingsData: standingsData,
			sortFieldIdx: sortFieldIdx,
			sortOrder: sortOrder
		});
	}

	render() {
		// console.log('STAND: RENDER (10B)');
		// console.log(this.state.standings);
		var standings = this.state.standings;
		var standingIdx = this.state.standingIdx;

		return (
			<div>
				{(standings.length > 1) ? this.dispStandTypesSelector(standings) : null}
				<br/>
				{(standings.length !== 0) ? this.dispStandings(standings, standingIdx) : null}

				<div className="no-print">
				{this.createLegend()}
				</div>
			</div>
		);
	}

// ALTERNATIVE pour afficher la sélection de classements, plutôt qu'un gros dropdown selector, on peut utiliser des catégories avec liens, comme sur espn.
// La fonction de base ressemble à ceci, mais il faut ajouter:
// - la génération automatique de cette function selon le nb de divisions
// - la fonction de sélection du classement
// - le changement sur la classe lorsque le lien est sélectionné ou pas.
/*
	dispStandTypesSelect2() {
		return (
			<div>
				Type de joueur: &nbsp;&nbsp;
				<a className="statelomenulink" id='tj0' onClick={this.clickA}>Réguliers</a> &nbsp;&nbsp;|&nbsp;&nbsp;
				<a className="statelomenulink" id='tj1' onClick={this.clickA}>Substituts</a>
				<br/>

				Division: &nbsp;&nbsp;
				<a className="statelomenulink" id='div0' onClick={this.clickA}>Général</a> &nbsp;&nbsp;|&nbsp;&nbsp;
				<a className="statelomenulink" id='div1' onClick={this.clickA}>Division Principale</a> &nbsp;&nbsp;|&nbsp;&nbsp;
				<a className="statelomenulink" id='div2' onClick={this.clickA}>Division Secondaire</a>
				<br/>

				Type: &nbsp;&nbsp;
				<a className="statelomenulink" id='typ0' onClick={this.clickA}>Tous</a> &nbsp;&nbsp;|&nbsp;&nbsp;
				<a className="statelomenulink" id='typ1' onClick={this.clickA}>Simple</a> &nbsp;&nbsp;|&nbsp;&nbsp;
				<a className="statelomenulink" id='typ2' onClick={this.clickA}>Double</a>
				<br/><br/>
			</div>
		);
	},
	clickA(e) {
		console.log(e.target.id);
	},
*/

	dispStandTypesSelector(standings) {
		return (
			<div className="row no-print">
			<div className="col-md-4">
				Options de classement
        <select className="form-control" value={this.state.standingIdx} onChange={this.standTypeChange}>
          {standings.map(this.createSelectItem)}
        </select>
			</div>
			</div>
		);
	}

  createSelectItem(standingsItem, standingsIdx) {
    return (
	    <option value={standingsIdx} key={"stdType" + standingsIdx}>
      	{standingsItem.title + ' - ' + standingsItem.standType}
      </option>
    );
  }

	standTypeChange(e) {
		this.resetAllSorting();
		this.setState({
			standingIdx: e.target.value
		});
		this.props.handleStandingIdxChange(e.target.value);
	}

	dispStandings(standings, standingsIdx) {
		var _this = this;
		var standingsItem = standings[standingsIdx];
		var standingsData = this.state.standingsData;

		return (
			<div className="row">
			<div className="col-md-12" key={'div.' + standingsIdx}>

				{/* NO-PRINT SECTION */}
				<div className="card no-print">
					<div className="card-header">
					<i className="fa fa-th-large"></i>
						{standingsItem.title.toUpperCase() + ' - ' + standingsItem.standType.toUpperCase()}
					</div>

					<div className="card-body card-block">
						<div className="table-responsive tableFixHeader resizeVerticalStandings">
							<table className="table table-striped table-hover table-sm tableFix2col">
							<thead>
							<tr>
								{cstTableHeaders.map(function(elem, idx) {
									return _this.createStandingHdrRow(standingsIdx, elem, idx)
								})}
							</tr>
							</thead>
							<tbody>
								{(standingsData[standingsIdx].length !== 0) ?
									standingsData[standingsIdx].map(this.createStandingRow) :
									<tr><td colSpan="99">(Aucune donnée)</td></tr>
								}
							</tbody>
							</table>
						</div>
			    </div>
				</div>

				{/* PRINT-ONLY SECTION*/}
				<div className="print-only">
					<h5>{standingsItem.title.toUpperCase() + ' - ' + standingsItem.standType.toUpperCase()}</h5>
					<div className="table-responsive print-container">
						<table className="table table-striped table-sm">
						<thead>
						<tr>
							{cstTableHeaders.map(function(elem, idx) {
								return _this.createStandingHdrRow(standingsIdx, elem, idx)
							})}
						</tr>
						</thead>
						<tbody>
								{(standingsData[standingsIdx].length !== 0) ?
									standingsData[standingsIdx].map(this.createStandingRow) :
									<tr><td colSpan="99">(Aucune donnée)</td></tr>
								}
						</tbody>
						</table>
					</div>
				</div>

			</div>
			</div>
		);
	}

	createStandingHdrRow(standingsIdx, hdrItem, hdrIdx) {
		var classNameStr = '';
		var onClickAction = function() {};

		// No header if no team (subs)
		if((this.state.standings[standingsIdx].showTeam === false) && (hdrIdx === cstTeamFieldIdx)) {
			return;
		}

		if((this.props.formatTeamIndiv === "INDIV") && (hdrIdx === cstTeamFieldIdx)) {
			return;
		}

		// Sort with arrows
		// No sort on Rank (column 0)
		if (hdrIdx !== 0) {
			onClickAction = this.handleSortTable;
			classNameStr = 'statelo-sorting';
			if(hdrIdx === this.state.sortFieldIdx) {
				if (this.state.sortOrder === "asc") {
					classNameStr += ' statelo-sorting_asc';
				} else {
					classNameStr += ' statelo-sorting_desc';
				}
			}
		}

		return (
			<th key={"colid." + standingsIdx + '.' + hdrIdx} 
				id={"colid." + standingsIdx + '.' + hdrIdx} 
				className={classNameStr}
				onClick={onClickAction}>
				{hdrItem}
			</th>
		);
	}

	createStandingRow(tableData, tableDataIdx) {
		return (
			<tr key={'te.' + tableDataIdx}>
				{tableData.map(this.createDataCell)}
	        </tr>
        );
	}

	createDataCell(dataCell, dataCellIdx) {
		if ((this.props.formatTeamIndiv === "INDIV") && (dataCellIdx === cstTeamFieldIdx)) {
			return;
		}

		// Fixed number of decimals, converting to string, for averages or any other stats
		cstFixedDecimalsStats.forEach(function(fdItem, fdIOdx) {
			if (dataCellIdx === fdItem.fieldIdx) {
				dataCell = dataCell.toFixed(fdItem.decimals);
			}
		})

		return (
			<td key={"tdcell." + dataCellIdx}>{dataCell}</td>
		);
	}

	/* https://stackoverflow.com/questions/29810914/react-js-onclick-cant-pass-value-to-method */ 
	handleSortTable(e) {
		var _this = this;
		var standingsIdx = parseInt(e.target.id.split(".")[1], 10);
		var sortFieldIdx = parseInt(e.target.id.split(".")[2], 10);

		var standingsData = this.state.standingsData;
		var sortOrder = this.state.sortOrder;
		var prevSortFieldIdx = this.state.sortFieldIdx;

		// Toggle sort order
		if (prevSortFieldIdx === sortFieldIdx) {
			if (sortOrder === 'asc') {
				sortOrder = 'desc';
			} else {
				sortOrder = 'asc';
			}
		} else {
			sortOrder = cstDefaultSortOrder[sortFieldIdx];
		}

		this.setState({
			sortOrder: sortOrder,
			sortFieldIdx: sortFieldIdx,
		});

		this.sortOneStandingsData(standingsData[standingsIdx], standingsIdx, sortFieldIdx, sortOrder);
	}

	createLegend() {
		return (
			<div className="row">
			<div className="col-md-8 col-xs-12">
				<div className="card">
					<div className="card-header">
					<i className="fa fa-th-large"></i>
						LÉGENDE
					</div>

				<div className="card-block">
				<table className="table table-striped table-hover table-sm">
					
				<tbody>
				<tr key='leg1'>
					<td><b>SMOY</b></td>
					<td>Super moyenne</td>
					<td><b>TP</b></td>
					<td>TRO pour</td>
				</tr>
				<tr key='leg2'>
					<td><b>MOY</b></td>
					<td>Moyenne (%)</td>
					<td><b>TC</b></td>
					<td>TRO contre</td>
				</tr>
				<tr key='leg3'>
					<td><b>PJ</b></td>
					<td>Parties jouées</td>
					<td><b>TBB</b></td>
					<td>TenBall breaks</td>
				</tr>
				<tr key='leg4'>
					<td><b>VIC</b></td>
					<td>Victoires</td>
					<td><b></b></td>
					<td></td>
				</tr>
					
				</tbody>
				</table>
				</div>
				</div>
			</div>

			{this.showPrintButton()}
			</div>
		);
	}

	getScabClassPoints(classStr) {
		const scabs = ["PRO", "SP", "AAA", "AA", "A", "B", "C"];
		const pts = [7, 6, 5, 4, 3, 2, 1];

		var scabClasses = classStr.split("&");
		var scabPoints = 0;
		var scabIdx = 0;
		var scabScore = 0;

		scabClasses.forEach(function(scabClass, scabClassIdx, scabClasses) {
			scabIdx = scabs.indexOf(scabClass.trim());
			if (scabIdx !== -1) {
				scabPoints += pts[scabIdx];
			}
		});
		
		// average scoring
		scabScore = scabPoints / scabClasses.length;

		// extra decimal to distinguish nb of players in team in sorting
		scabScore += (scabClasses.length / 100);
		return scabScore;
	}

	showPrintButton() {
		return (
			<div className="col-md-4 no-print">
				<button className="btn btn-secondary btn-sm btn-fluid pull-right" 
					onClick={this.printTable}> <i className="fa fa-print"></i>&nbsp;&nbsp;Imprimer le classement </button>

				<br/><br/>
				<div className="pull-right">
					<input type="checkbox" onChange={this.props.togglePrintLeagueMsg} checked={this.props.printLeagueMsg || false} />
					&nbsp;&nbsp;Imprimer le message de ligue
				</div>
			</div>
		)
	}

	printTable() {
		// replaceState remplace le URL affiché sur le printout
		var curURL = window.location.href;
		window.history.replaceState(history.state, '', '/');
		window.print();
		window.history.replaceState(history.state, '', curURL);
	}

}

export default PlayerStandings_10B;
